import { useCallback } from 'react';
import { useDispatch } from '@betty/toolkit/state';
import { openChat } from '@betty/chat/state';
import { Icon, Box, Text, Button } from '@betty/moonlight';
import { FOOTER_LINKS, SOCIAL_LINKS } from './FooterLinks.constants';
import FooterLink from '../FooterLink/FooterLink';
import SocialLink from '../../SocialLink/SocialLink';

function FooterLinks() {
  const dispatch = useDispatch();

  const onChatPress = useCallback(() => {
    dispatch(openChat());
  }, [dispatch]);

  return (
    <Box
      gap="space-1000"
      maxWidth={{
        desktop: 420,
        tablet: 420,
        mobile: '100%',
      }}
      flex={1}
      flexDirection={{
        desktop: 'row',
        tablet: 'row',
        mobile: 'column',
      }}
      flexWrap="wrap"
      alignItems="flex-start"
    >
      <Box
        gap="space-400"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        flex={1}
        width={{
          desktop: undefined,
          tablet: undefined,
          mobile: '100%',
        }}
      >
        <Box gap="space-400">
          <Icon name="bettyLogo" height={28} width={63} />
          <Text
            variant="overline"
            color="darkSurfacePrimary"
            locNS="account"
            locKey="meTime"
          />
        </Box>
        <Button
          variant="secondary"
          locNS="common"
          locKey="liveChat"
          onPress={onChatPress}
          display={{
            desktop: 'none',
            tablet: 'none',
            mobile: 'flex',
          }}
          leftIcon="supportAgent"
        />
      </Box>
      <Box
        flexDirection={{
          desktop: 'row',
          tablet: 'column',
          mobile: 'column',
        }}
        gap={{
          desktop: 'space-400',
          tablet: 'space-0',
          mobile: 'space-0',
        }}
        flex={2}
      >
        <Box flexDirection="column">
          {FOOTER_LINKS.slice(0, 4).map((link, index) => (
            <FooterLink {...link} key={index} />
          ))}
        </Box>
        <Box flexDirection="column">
          {FOOTER_LINKS.slice(4).map((link, index) => (
            <FooterLink {...link} key={index} />
          ))}
        </Box>
      </Box>
      <Box flexDirection="row" width="100%">
        {SOCIAL_LINKS.map((link, index) => (
          <SocialLink {...link} key={index} />
        ))}
      </Box>
    </Box>
  );
}

export default FooterLinks;
